module.exports = __webpack_public_path__ + "static/image3-66946419c872d9e1dfefba9b18fb0ce7.jpg";